import {
  canViewerPermission,
  getViewerEmailFromStorage,
  getViewerRoleType,
} from "./userMatrixStorage";
import { isPluginEnabled, PLUGIN_IDS } from "./registry";

function normalizeRoleName(name) {
  return String(name || "")
    .trim()
    .toLowerCase()
    .replace(/\s+/g, " ");
}

export function isExecutiveRoleType(roleType) {
  return normalizeRoleName(roleType?.name) === "executive";
}

export function shopPluginEnabled() {
  return isPluginEnabled(PLUGIN_IDS.MARKETPLACE);
}

/** Marketplace Shop page / nav — default on; Executive role defaults off via User Matrix. */
export function canAccessShop(viewerEmail) {
  if (!shopPluginEnabled()) return false;
  const email = viewerEmail ?? getViewerEmailFromStorage();
  const role = getViewerRoleType(email);
  if (isExecutiveRoleType(role)) {
    // Explicit matrix flag wins; missing key stays denied for Executive.
    return canViewerPermission(email, "canAccessShop", false);
  }
  return canViewerPermission(email, "canAccessShop", true);
}
